export enum ConditionalFilterCombiner {
  And = 'AND',
  Or = 'OR',
}
